import { CSSProperties } from 'react';

export interface UIComponentProps {
  id?: string;
  className?: string;
  style?: CSSProperties;
  tabIndex?: number;
}

export const getUIComponentProps = (props: UIComponentProps & any) => {
  const keys = [
    'id',
    'className',
    'style',
    'tabIndex',
  ];
  return keys.filter((key) => props[key] !== undefined).reduce((res, key) => ({
    ...res,
    [key]: props[key] || undefined,
  }), {});
}